module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block] + '-header',
    domProps: {
      "innerHTML": _vm._s(_vm.data.header)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "application-free"
  }, [_vm._v(_vm._s(_vm.data.badgeTxt))]), _vm._v(" "), _c('div', {
    class: [_vm.block] + '-text',
    domProps: {
      "innerHTML": _vm._s(_vm.data.text)
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block] + '-image',
    style: ({
      backgroundImage: 'url(' + _vm.src + ')'
    })
  }), _vm._v(" "), _c('div', {
    class: [_vm.block] + '-subText'
  }, [_c('router-link', {
    class: [_vm.block + '-link'],
    attrs: {
      "to": '/' + _vm.data.route
    }
  }, [_vm._v(_vm._s(_vm.data.link))]), _vm._v("\n        " + _vm._s(_vm.data.subText) + "\n      ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c073c8","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/Application.vue
// module id = 463
// module chunks = 0